import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import LoadingScreen from '@/components/loading-screen';
import { useImpersonation } from '@/contexts/ImpersonationContext';
import useAccessibleAccounts from '@/hooks/useAccessibleAccounts';
import ImpersonationGuard from './ImpersonationGuard';
import { LoggedUserScopeProvider } from './loggedUserScope';

// O Meu perfil fica fechado dentro da conta de outra pessoa (CKTPL-1726): lá ele mostrava e
// alterava o cadastro do titular. Com o seletor de conta e negócio (CBK-595), ele volta a abrir,
// mas com o cadastro de quem está logado (CBK-676), e o titular continua fora do alcance.
export default function ProfileImpersonationGuard({ children }) {
  const { impersonatedUserId } = useImpersonation();
  const { isAvailable, isLoading } = useAccessibleAccounts();

  if (!impersonatedUserId) {
    return children;
  }

  if (isLoading) {
    return <LoadingScreen />;
  }

  if (!isAvailable) {
    return <Navigate to="/403" replace />;
  }

  return (
    <ImpersonationGuard>
      <LoggedUserScopeProvider>{children}</LoggedUserScopeProvider>
    </ImpersonationGuard>
  );
}

ProfileImpersonationGuard.propTypes = {
  children: PropTypes.node,
};
